import { AbstractDTO } from "./abstract";

export class ProductDTO extends AbstractDTO {
    id:  number;
    Name: string;
    Price: number;
    ProductName: string;
    group_id: number;
    product_code: string;
    product_pic: string;

    constructor(attributes: object) {
        super(attributes);
        attributes = attributes ? attributes : {};

        this.id = attributes['id'] >= 0 ? Number(attributes['id']) : -1;
        this.Name = attributes['Name'] || "";
        this.Price = Number(attributes['Price']) || 0;
        this.ProductName = attributes['ProductName'] || "";
        this.group_id = Number(attributes['group_id']) || 0;
        this.product_code = attributes['product_code'] || "";
        this.product_pic = attributes['product_pic'] || "";
    }
}